<!-- Ratios de Syntage: una tabla densa por grupo, en rejilla de 2; los que no traen ningún valor van en una línea debajo -->
<div class="ratios-grid" *ngIf="groups.length; else noRatios">
  <div class="alg-block ratio-group" *ngFor="let group of groups; trackBy: trackByIdx" [attr.data-test]="'ratio-group-' + group.key">
    <h4 class="ratios-title">{{ group.label }}</h4>
    <div class="alg-table-wrap">
      <table class="alg-table ratios-table">
        <caption class="p-hidden-accessible">
          {{
            'Ratios de ' + group.label.toLowerCase() + ' por año según Syntage'
          }}
        </caption>
        <thead>
          <tr>
            <th scope="col" class="ratio-name-col">Ratio</th>
            <th scope="col" class="is-num" *ngFor="let year of years; trackBy: trackByIdx">{{ year }}</th>
            <th scope="col" class="is-num">Último</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let card of group.cards; trackBy: trackByIdx" data-test="ratio-row">
            <th scope="row" class="ratio-name">{{ card.label }}</th>
            <td class="is-num" *ngFor="let point of card.years; trackBy: trackByIdx" data-test="ratio-year">
              {{ point.value }}
            </td>
            <td class="is-num is-strong" data-test="ratio-latest">{{ card.latest }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="ratio-missing" *ngIf="group.missing.length" data-test="ratio-missing">Sin dato: {{ group.missing.join(' · ') }}</p>
  </div>
</div>
<ng-template #noRatios>
  <p class="ratio-missing" data-test="syntage-ratios-empty">Syntage no entregó ratios financieros para este análisis.</p>
</ng-template>
